import React from "react";
import { createRoot } from "react-dom/client";
import type { OauthAppsPropTypes } from "@/react/prop-types";
import OauthAppsTable from "./components/oauth-apps-table";
import EnvironmentI18n from "./providers/EnvironmentI18n";

export default (props: OauthAppsPropTypes) => {
   const container = document.getElementById("oauth-apps-react-mount");
   const root = createRoot(container!);
   root.render(
      <EnvironmentI18n locale={(window.I18n?.locale as any) ?? "en"}>
         <OauthAppsTable {...props} />
      </EnvironmentI18n>,
   );
};
